import React from 'react';

const isMac =
  typeof navigator !== 'undefined' &&
  /Mac|iPhone|iPad|iPod/.test(navigator.platform);

const MOD = isMac ? '⌘' : 'Ctrl';

/**
 * Renders a tooltip label with an appended keyboard shortcut.
 * The shortcut is shown in bold with a platform-aware modifier key.
 *
 * @example shortcutLabel('Play', 'Space')        → "Play  Space"
 * @example shortcutLabel('Rewind', 'Ctrl+←')     → "Rewind  ⌘←" (Mac) / "Rewind  Ctrl+←" (Win)
 */
export function shortcutLabel(
  label: string,
  shortcut: string
): React.ReactElement {
  const display = shortcut
    .replace(/Ctrl\+/g, `${MOD}+`)
    .replace(/Meta\+/g, `${MOD}+`)
    .replace(/\+/g, '')
    .replace('ArrowLeft', '←')
    .replace('ArrowRight', '→')
    .replace('ArrowUp', '↑')
    .replace('ArrowDown', '↓');

  return (
    <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
      {label}
      <kbd className="font-bold opacity-70 text-[10px]">{display}</kbd>
    </span>
  );
}
